import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Divider, List, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import get from 'lodash/get';

// project imports
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const NavGroup = ({ item }) => {
    const {
        admin: { profile }
    } = useSelector((state) => state.auth);
    const theme = useTheme();

    const currentRole = () => {
        if (get(profile, 'is_superuser', false)) {
            return ['super', 'admin'];
        }

        if (get(profile, 'optik_group', false)) {
            return ['admin-group'];
        }

        if (get(profile, 'is_staff', false)) {
            return ['admin'];
        }

        return [];
    };

    // menu list collapse & items
    const items = item.children?.map((menu) => {
        // const accepted = currentRole?.indexOf(menu?.allowedPermission) >= 0;
        const accepted = currentRole().some((v) => menu?.allowedPermission.indexOf(v) >= 0);

        if (!accepted) return <></>;

        switch (menu.type) {
            case 'collapse':
                return <NavCollapse key={menu.id} menu={menu} level={1} />;
            case 'item':
                if (!accepted) {
                    // eslint-disable-next-line consistent-return
                    return;
                }
                return <NavItem key={menu.id} item={menu} level={1} />;
            default:
                return (
                    <Typography key={menu.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return (
        <>
            <List
                subheader={
                    item.title && (
                        <Typography variant="caption" sx={{ ...theme.typography.menuCaption }} display="block" gutterBottom>
                            {item.title}
                            {item.caption && (
                                <Typography variant="caption" sx={{ ...theme.typography.subMenuCaption }} display="block" gutterBottom>
                                    {item.caption}
                                </Typography>
                            )}
                        </Typography>
                    )
                }
            >
                {items}
            </List>

            {/* group divider */}
            <Divider sx={{ mt: 0.25, mb: 1.25 }} />
        </>
    );
};

NavGroup.propTypes = {
    item: PropTypes.object
};

export default NavGroup;
